// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

.breadcrumb {
  margin-top: 1.5rem;
  margin-left: 1.5rem;
}

.breadcrumb-nav {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 0 1.25rem;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.875rem;
}

.breadcrumb-link {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--ca-primary, #0e2e80);
  font: inherit;
  text-decoration: none;
  cursor: pointer;
}
.breadcrumb-link:hover {
  color: var(--ca-primary-dark, #0d2863);
  text-decoration: underline;
}
.breadcrumb-link:focus-visible {
  outline: 3px solid rgba(40, 80, 173, 0.25);
  outline-offset: 3px;
  border-radius: var(--ca-radius-sm, 6px);
}

.breadcrumb-link i {
  font-size: 1.25rem;
}

.breadcrumb-separator {
  color: var(--ca-text-muted, #8c96a8);
}

.breadcrumb-current {
  color: var(--ca-text-secondary, #4b5870);
  font-weight: 500;
}

.breadcrumb-current i {
  font-size: 1.25rem;
}

.file-system-asset-setup {
  width: 100%;
  padding-top: 1.25rem;
  padding-bottom: 2.5rem;
}

.setup-page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1.5rem;
  margin-bottom: 1.5rem;
}

.setup-page-header h1 {
  margin: 0 0 0.45rem;
  color: var(--ca-text-primary, #172033);
  font-size: clamp(1.55rem, 2vw, 1.9rem);
  font-weight: 700;
  letter-spacing: -0.025em;
}

.eyebrow {
  margin: 0 0 0.35rem;
  color: var(--ca-primary, #0e2e80);
  font-size: 0.7rem;
  font-weight: 800;
  letter-spacing: 0.11em;
}

.page-description {
  max-width: 760px;
  margin: 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.93rem;
}

.source-type-chip,
.format-pill,
.count-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  flex-shrink: 0;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: 999px;
  background: #fff;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.78rem;
  font-weight: 600;
  padding: 0.48rem 0.8rem;
}

.source-type-chip i {
  color: var(--ca-primary, #0e2e80);
}

.setup-card {
  overflow: hidden;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: 16px;
  background: var(--ca-surface, #fff);
  box-shadow: 0 4px 16px rgba(7, 17, 46, 0.055);
}

.setup-stepper {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid var(--ca-border-light, #e9edf3);
  background: #fbfcff;
}

.stepper-item {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
  padding-right: 1rem;
}

.stepper-item:not(:last-child)::after {
  position: absolute;
  top: 1rem;
  right: 0.85rem;
  left: 2.7rem;
  height: 1px;
  background: var(--ca-border, #dfe4ec);
  content: "";
  transform: translateX(1rem);
}

.stepper-marker {
  z-index: 1;
  display: grid;
  width: 2rem;
  height: 2rem;
  flex: 0 0 2rem;
  place-items: center;
  border: 1px solid var(--ca-border, #dfe4ec);
  border-radius: 50%;
  background: #fff;
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.82rem;
  font-weight: 700;
}

.stepper-item.active .stepper-marker,
.stepper-item.completed .stepper-marker {
  border-color: var(--ca-primary, #0e2e80);
  background: var(--ca-primary, #0e2e80);
  color: #fff;
}

.stepper-copy {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 0.1rem;
}

.stepper-title {
  color: var(--ca-text-primary, #172033);
  font-size: 0.84rem;
  font-weight: 700;
}

.stepper-description {
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.72rem;
}

.stepper-item:not(.active):not(.completed) .stepper-title {
  color: var(--ca-text-muted, #8c96a8);
}

.wizard-panel {
  padding: clamp(1.25rem, 3vw, 2rem);
}

.panel-heading {
  display: flex;
  align-items: flex-start;
  gap: 0.9rem;
  margin-bottom: 1.5rem;
}

.panel-heading-icon {
  display: grid;
  width: 2.75rem;
  height: 2.75rem;
  flex: 0 0 2.75rem;
  place-items: center;
  border-radius: 12px;
  background: #edf3ff;
  color: var(--ca-primary, #0e2e80);
  font-size: 1.2rem;
}

.panel-heading-icon.success-icon {
  background: #eaf7f0;
  color: #198754;
}

.panel-heading h2 {
  margin: 0 0 0.3rem;
  color: var(--ca-text-primary, #172033);
  font-size: 1.18rem;
  font-weight: 700;
}

.panel-heading p {
  margin: 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.88rem;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.25rem 1.5rem;
}

.field-group {
  min-width: 0;
}

.field-full {
  grid-column: 1/-1;
}

.form-label {
  display: inline-block;
  margin-bottom: 0.45rem;
  color: var(--ca-text-primary, #172033);
  font-size: 0.84rem;
  font-weight: 650;
}

.required-mark {
  color: #dc3545;
}

.form-control,
.form-select {
  min-height: 2.75rem;
  border-color: var(--ca-input-border, #dfe4ec);
  border-radius: 8px;
  color: var(--ca-text-primary, #172033);
  font-size: 0.9rem;
  box-shadow: none;
}

.form-control:focus,
.form-select:focus {
  border-color: var(--ca-input-focus, #2850ad);
  box-shadow: 0 0 0 0.2rem rgba(40, 80, 173, 0.13);
}

.field-hint,
.field-error {
  display: block;
  margin-top: 0.35rem;
  font-size: 0.76rem;
}

.field-hint {
  color: var(--ca-text-muted, #8c96a8);
}

.field-error {
  color: #dc3545;
}

.identity-note,
.summary-note {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  margin-top: 1.5rem;
  padding: 0.9rem 1rem;
  border: 1px solid #dce6ff;
  border-radius: 10px;
  background: #f5f8ff;
  color: #435574;
  font-size: 0.82rem;
}

.identity-note i,
.summary-note i {
  margin-top: 0.1rem;
  color: var(--ca-primary, #0e2e80);
  font-size: 1rem;
}

.wizard-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 2rem;
  padding-top: 1.25rem;
  border-top: 1px solid var(--ca-border-light, #e9edf3);
}

.wizard-actions-between {
  justify-content: space-between;
}

.action-group {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 0.65rem;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 2.55rem;
  border-radius: 8px;
  font-size: 0.84rem;
  font-weight: 650;
  padding: 0.55rem 1rem;
}

.btn-primary {
  border-color: var(--ca-primary, #0e2e80);
  background: var(--ca-primary, #0e2e80);
}

.btn-primary:hover:not(:disabled) {
  border-color: var(--ca-primary-dark, #0d2863);
  background: var(--ca-primary-dark, #0d2863);
}

.btn-outline-primary {
  border-color: var(--ca-primary, #0e2e80);
  color: var(--ca-primary, #0e2e80);
}

.btn-outline-primary:hover:not(:disabled) {
  background: #edf3ff;
  color: var(--ca-primary, #0e2e80);
}

.choice-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
}

.choice-card {
  display: flex;
  align-items: flex-start;
  gap: 0.9rem;
  width: 100%;
  min-width: 0;
  padding: 1.1rem;
  border: 1px solid var(--ca-border, #dfe4ec);
  border-radius: 12px;
  background: #fff;
  color: inherit;
  text-align: left;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}

.choice-card:hover:not(:disabled) {
  border-color: #9db7f6;
  background: #fbfcff;
}

.choice-card.selected {
  border-color: var(--ca-primary, #0e2e80);
  background: #f5f8ff;
  box-shadow: inset 0 0 0 1px var(--ca-primary, #0e2e80);
}

.choice-card:disabled {
  cursor: not-allowed;
  opacity: 0.8;
}

.choice-icon {
  display: grid;
  width: 2.55rem;
  height: 2.55rem;
  flex: 0 0 2.55rem;
  place-items: center;
  border-radius: 10px;
  background: #edf3ff;
  color: var(--ca-primary, #0e2e80);
  font-size: 1.12rem;
}

.choice-icon.secondary {
  background: #f1f3f6;
  color: #667085;
}

.choice-content {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 0.35rem;
  min-width: 0;
}

.choice-content strong {
  color: var(--ca-text-primary, #172033);
  font-size: 0.9rem;
}

.choice-content span {
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.8rem;
  line-height: 1.5;
}

.selection-indicator {
  margin-top: 0.15rem;
  color: var(--ca-text-muted, #8c96a8);
  font-size: 1.05rem;
}

.choice-card.selected .selection-indicator {
  color: var(--ca-primary, #0e2e80);
}

.file-import-panel {
  margin-top: 1.5rem;
  padding: 1.25rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: 12px;
  background: #fcfdff;
}

.file-panel-heading,
.table-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
}

.file-panel-heading h3,
.table-heading h3 {
  margin: 0 0 0.25rem;
  color: var(--ca-text-primary, #172033);
  font-size: 0.98rem;
  font-weight: 700;
}

.file-panel-heading p,
.table-heading p {
  margin: 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.8rem;
}

.format-pill {
  border-color: #dce6ff;
  background: #f5f8ff;
  color: var(--ca-primary, #0e2e80);
}

.file-dropzone {
  display: flex;
  min-height: 210px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  padding: 1.5rem;
  border: 1.5px dashed #b8c5dd;
  border-radius: 12px;
  background: #fff;
  text-align: center;
}

.file-dropzone.has-file {
  border-style: solid;
  border-color: #b7e3ca;
  background: #fbfefc;
}

.dropzone-icon {
  display: grid;
  width: 3.1rem;
  height: 3.1rem;
  margin-bottom: 0.25rem;
  place-items: center;
  border-radius: 50%;
  background: #edf3ff;
  color: var(--ca-primary, #0e2e80);
  font-size: 1.4rem;
}

.file-selected-icon {
  background: #eaf7f0;
  color: #198754;
}

.file-dropzone > strong {
  color: var(--ca-text-primary, #172033);
  font-size: 0.91rem;
}

.file-dropzone > span:not(.dropzone-icon) {
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.8rem;
}

.selected-file-name {
  max-width: 100%;
  overflow-wrap: anywhere;
}

.browse-button {
  margin-top: 0.55rem;
  cursor: pointer;
}

.text-button {
  border: 0;
  background: transparent;
  color: #b42332;
  font-size: 0.8rem;
  font-weight: 650;
  text-decoration: underline;
}

.file-error {
  margin-top: 0.65rem;
}

.import-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 1rem;
}

.import-context {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  max-width: 620px;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.78rem;
}

.import-context i {
  margin-top: 0.05rem;
  color: var(--ca-primary, #0e2e80);
}

.import-result {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  margin-top: 1rem;
  padding: 0.85rem 1rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: 9px;
  background: #f8faff;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.82rem;
}

.import-result-success {
  border-color: #b7e3ca;
  background: #f1fbf5;
  color: #17653d;
}

.import-result-error {
  border-color: #f3b9c0;
  background: #fff5f6;
  color: #a51f2d;
}

.imported-assets-section {
  margin-top: 1.5rem;
}

.table-heading {
  align-items: center;
}

.count-pill {
  border-color: #dce6ff;
  background: #f5f8ff;
  color: var(--ca-primary, #0e2e80);
}

.assets-table-wrapper {
  overflow: auto;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: 10px;
}

.assets-table {
  min-width: 780px;
  margin: 0;
  font-size: 0.8rem;
}

.assets-table thead th {
  padding: 0.85rem 1rem;
  border-bottom-color: var(--ca-border, #dfe4ec);
  background: #f5f7fb;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.72rem;
  font-weight: 750;
  letter-spacing: 0.025em;
  white-space: nowrap;
}

.assets-table tbody td {
  padding: 0.85rem 1rem;
  border-bottom-color: var(--ca-border-light, #e9edf3);
  color: var(--ca-text-secondary, #4b5870);
  vertical-align: middle;
}

.assets-table tbody tr:last-child td {
  border-bottom: 0;
}

.assets-table tbody tr:hover {
  background: #fbfcff;
}

.assets-table td strong {
  display: block;
  color: var(--ca-text-primary, #172033);
  font-size: 0.82rem;
}

.asset-description {
  display: block;
  max-width: 260px;
  margin-top: 0.2rem;
  overflow: hidden;
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.72rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.status-pill {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  background: #f1f3f6;
  color: #667085;
  font-size: 0.7rem;
  font-weight: 700;
  padding: 0.25rem 0.55rem;
  text-transform: capitalize;
}

.status-pill.status-active {
  background: #eaf7f0;
  color: #198754;
}

.empty-assets-state {
  display: flex;
  min-height: 150px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  border: 1px dashed var(--ca-border, #dfe4ec);
  border-radius: 10px;
  color: var(--ca-text-muted, #8c96a8);
  text-align: center;
}

.empty-assets-state i {
  color: var(--ca-primary, #0e2e80);
  font-size: 1.5rem;
}

.empty-assets-state strong {
  color: var(--ca-text-primary, #172033);
  font-size: 0.88rem;
}

.empty-assets-state span {
  font-size: 0.78rem;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.9rem;
}

.summary-item {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 0.4rem;
  padding: 1rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: 10px;
  background: #fff;
}

.summary-item-full {
  grid-column: 1/-1;
}

.summary-label {
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.74rem;
  font-weight: 650;
}

.summary-item strong {
  overflow-wrap: anywhere;
  color: var(--ca-text-primary, #172033);
  font-size: 0.9rem;
  font-weight: 700;
}

.summary-item .summary-success {
  color: #198754;
}

.summary-long-value {
  font-size: 0.8rem !important;
}

.summary-note code {
  border-radius: 4px;
  background: #e8eeff;
  color: var(--ca-primary, #0e2e80);
  font-size: 0.8rem;
  padding: 0.12rem 0.28rem;
}

.update-panel {
  max-width: 960px;
  margin: 0 auto;
}

.section-divider-label {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin: 0 0 1.25rem;
  color: var(--ca-text-primary, #172033);
  font-size: 0.82rem;
  font-weight: 700;
}

.section-divider-label::after {
  flex: 1;
  height: 1px;
  background: var(--ca-border-light, #e9edf3);
  content: "";
}

.readonly-value {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  min-height: 2.75rem;
  padding: 0.65rem 0.8rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: 8px;
  background: var(--ca-surface-muted, #f7f9fc);
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.9rem;
}

.readonly-value i {
  color: var(--ca-primary, #0e2e80);
  font-size: 1rem;
}

.update-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  min-height: 220px;
  padding: 2rem;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.9rem;
}

.update-load-error {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.85rem;
  padding: 1.5rem;
  color: var(--ca-text-secondary, #4b5870);
}

.update-load-error > i {
  color: #dc3545;
  font-size: 1.2rem;
}

.update-load-error > span {
  flex: 1 1 220px;
}

@media (max-width: 640px) {
  .update-panel {
    padding: 1rem;
  }
  .update-panel .form-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .update-panel .field-full {
    grid-column: auto;
  }
  .update-panel .wizard-actions {
    align-items: stretch;
    flex-direction: column-reverse;
  }
  .update-panel .wizard-actions .btn {
    width: 100%;
  }
}
@media (max-width: 850px) {
  .setup-page-header {
    flex-direction: column;
  }
  .setup-stepper {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  .stepper-item:not(:last-child)::after {
    display: none;
  }
  .choice-grid {
    grid-template-columns: 1fr;
  }
  .stepper-description {
    display: none;
  }
}
@media (max-width: 600px) {
  .file-setup-breadcrumb {
    padding-right: 1rem;
    padding-left: 1rem;
  }
  .file-system-asset-setup {
    padding-right: 1rem;
    padding-left: 1rem;
  }
  .form-grid,
  .summary-grid {
    grid-template-columns: 1fr;
  }
  .field-full,
  .summary-item-full {
    grid-column: auto;
  }
  .wizard-panel {
    padding: 1rem;
  }
  .import-actions,
  .wizard-actions-between {
    align-items: stretch;
    flex-direction: column;
  }
  .action-group {
    justify-content: flex-end;
  }
  .wizard-actions > .btn,
  .action-group .btn {
    flex: 1 1 auto;
  }
  .file-panel-heading,
  .table-heading {
    align-items: flex-start;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/features/shared-workflows/system-asset-capture/system-asset-capture-file-create-or-update/system-asset-capture-file-create-or-update.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAEA;EACE,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,uCAAA;EACA,mBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,iCAAA;EACA,aAAA;EACA,qBAAA;EACA,eAAA;AACF;AACE;EACE,sCAAA;EACA,0BAAA;AACJ;AAEE;EACE,0CAAA;EACA,mBAAA;EACA,uCAAA;AAAJ;;AAIA;EACE,kBAAA;AADF;;AAIA;EACE,oCAAA;AADF;;AAIA;EAEE,wCAAA;EACA,gBAAA;AAFF;;AAKA;EACE,kBAAA;AAFF;;AAKA;EACE,WAAA;EACA,oBAAA;EACA,sBAAA;AAFF;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,WAAA;EACA,qBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,sCAAA;EACA,sCAAA;EACA,gBAAA;EACA,wBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,iCAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,SAAA;EACA,wCAAA;EACA,kBAAA;AAFF;;AAKA;;;EAGE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,iDAAA;EACA,oBAAA;EACA,gBAAA;EACA,wCAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;AAFF;;AAKA;EACE,iCAAA;AAFF;;AAKA;EACE,gBAAA;EACA,iDAAA;EACA,mBAAA;EACA,mCAAA;EACA,6CAAA;AAFF;;AAKA;EACE,aAAA;EACA,gDAAA;EACA,MAAA;EACA,uBAAA;EACA,wDAAA;EACA,mBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,SAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,qCAAA;EACA,WAAA;EACA,2BAAA;AAFF;;AAKA;EACE,UAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,2CAAA;EACA,kBAAA;EACA,gBAAA;EACA,oCAAA;EACA,kBAAA;EACA,gBAAA;AAFF;;AAKA;;EAEE,wCAAA;EACA,sCAAA;EACA,WAAA;AAFF;;AAKA;EACE,aAAA;EACA,YAAA;EACA,sBAAA;EACA,WAAA;AAFF;;AAKA;EACE,sCAAA;EACA,kBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,oCAAA;EACA,kBAAA;AAFF;;AAKA;EACE,oCAAA;AAFF;;AAKA;EACE,kCAAA;AAFF;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,qBAAA;AAFF;;AAKA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iCAAA;EACA,iBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,cAAA;AAFF;;AAKA;EACE,kBAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,SAAA;EACA,wCAAA;EACA,kBAAA;AAFF;;AAKA;EACE,aAAA;EACA,gDAAA;EACA,mBAAA;AAFF;;AAKA;EACE,YAAA;AAFF;;AAKA;EACE,iBAAA;AAFF;;AAKA;EACE,qBAAA;EACA,sBAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,cAAA;AAFF;;AAKA;;EAEE,mBAAA;EACA,6CAAA;EACA,kBAAA;EACA,sCAAA;EACA,iBAAA;EACA,gBAAA;AAFF;;AAKA;;EAEE,4CAAA;EACA,gDAAA;AAFF;;AAKA;;EAEE,cAAA;EACA,mBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,oCAAA;AAFF;;AAKA;EACE,cAAA;AAFF;;AAKA;;EAEE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AAFF;;AAKA;;EAEE,kBAAA;EACA,iCAAA;EACA,eAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,oBAAA;EACA,qDAAA;AAFF;;AAKA;EACE,8BAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,YAAA;AAFF;;AAKA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AAFF;;AAKA;EACE,wCAAA;EACA,sCAAA;AAFF;;AAKA;EACE,6CAAA;EACA,2CAAA;AAFF;;AAKA;EACE,wCAAA;EACA,iCAAA;AAFF;;AAKA;EACE,mBAAA;EACA,iCAAA;AAFF;;AAKA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AAFF;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,2CAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,gEAAA;AAFF;;AAKA;EACE,qBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,wCAAA;EACA,mBAAA;EACA,sDAAA;AAFF;;AAKA;EACE,mBAAA;EACA,YAAA;AAFF;;AAKA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iCAAA;EACA,kBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,cAAA;AAFF;;AAKA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;AAFF;;AAKA;EACE,sCAAA;EACA,iBAAA;AAFF;;AAKA;EACE,wCAAA;EACA,iBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,oCAAA;EACA,kBAAA;AAFF;;AAKA;EACE,iCAAA;AAFF;;AAKA;EACE,kBAAA;EACA,gBAAA;EACA,iDAAA;EACA,mBAAA;EACA,mBAAA;AAFF;;AAKA;;EAEE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AAFF;;AAKA;;EAEE,mBAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;AAFF;;AAKA;;EAEE,SAAA;EACA,wCAAA;EACA,iBAAA;AAFF;;AAKA;EACE,qBAAA;EACA,mBAAA;EACA,iCAAA;AAFF;;AAKA;EACE,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,4BAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,qBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,aAAA;EACA,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iCAAA;EACA,iBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,cAAA;AAFF;;AAKA;EACE,sCAAA;EACA,kBAAA;AAFF;;AAKA;EACE,oCAAA;EACA,iBAAA;AAFF;;AAKA;EACE,eAAA;EACA,uBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,eAAA;AAFF;;AAKA;EACE,SAAA;EACA,uBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,0BAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;AAFF;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,wCAAA;EACA,kBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,iCAAA;AAFF;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;EACA,iDAAA;EACA,kBAAA;EACA,mBAAA;EACA,wCAAA;EACA,kBAAA;AAFF;;AAKA;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;AAFF;;AAKA;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;AAFF;;AAKA;EACE,kBAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,qBAAA;EACA,mBAAA;EACA,iCAAA;AAFF;;AAKA;EACE,cAAA;EACA,iDAAA;EACA,mBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,SAAA;EACA,iBAAA;AAFF;;AAKA;EACE,qBAAA;EACA,8CAAA;EACA,mBAAA;EACA,wCAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,qBAAA;EACA,oDAAA;EACA,wCAAA;EACA,sBAAA;AAFF;;AAKA;EACE,gBAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,cAAA;EACA,sCAAA;EACA,kBAAA;AAFF;;AAKA;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oCAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,oBAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,wBAAA;EACA,0BAAA;AAFF;;AAKA;EACE,mBAAA;EACA,cAAA;AAFF;;AAKA;EACE,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,4CAAA;EACA,mBAAA;EACA,oCAAA;EACA,kBAAA;AAFF;;AAKA;EACE,iCAAA;EACA,iBAAA;AAFF;;AAKA;EACE,sCAAA;EACA,kBAAA;AAFF;;AAKA;EACE,kBAAA;AAFF;;AAKA;EACE,aAAA;EACA,gDAAA;EACA,WAAA;AAFF;;AAKA;EACE,aAAA;EACA,YAAA;EACA,sBAAA;EACA,WAAA;EACA,aAAA;EACA,iDAAA;EACA,mBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,iBAAA;AAFF;;AAKA;EACE,oCAAA;EACA,kBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,uBAAA;EACA,sCAAA;EACA,iBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,cAAA;AAFF;;AAKA;EACE,4BAAA;AAFF;;AAKA;EACE,kBAAA;EACA,mBAAA;EACA,iCAAA;EACA,iBAAA;EACA,wBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,cAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,OAAA;EACA,WAAA;EACA,2CAAA;EACA,WAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,iDAAA;EACA,kBAAA;EACA,4CAAA;EACA,wCAAA;EACA,iBAAA;AAFF;;AAKA;EACE,iCAAA;EACA,eAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,wCAAA;EACA,iBAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,wCAAA;AAFF;;AAKA;EACE,cAAA;EACA,iBAAA;AAFF;;AAKA;EACE,eAAA;AAFF;;AAKA;EACE;IACE,aAAA;EAFF;EAKA;IACE,qCAAA;EAHF;EAMA;IACE,iBAAA;EAJF;EAOA;IACE,oBAAA;IACA,8BAAA;EALF;EAQA;IACE,WAAA;EANF;AACF;AASA;EACE;IACE,sBAAA;EAPF;EAUA;IACE,0BAAA;IACA,SAAA;EARF;EAWA;IACE,aAAA;EATF;EAYA;IACE,0BAAA;EAVF;EAaA;IACE,aAAA;EAXF;AACF;AAcA;EACE;IACE,mBAAA;IACA,kBAAA;EAZF;EAeA;IACE,mBAAA;IACA,kBAAA;EAbF;EAgBA;;IAEE,0BAAA;EAdF;EAiBA;;IAEE,iBAAA;EAfF;EAkBA;IACE,aAAA;EAhBF;EAmBA;;IAEE,oBAAA;IACA,sBAAA;EAjBF;EAoBA;IACE,yBAAA;EAlBF;EAqBA;;IAEE,cAAA;EAnBF;EAsBA;;IAEE,uBAAA;EApBF;AACF","sourcesContent":[":host {\n  display: block;\n}\n\n.breadcrumb {\n  margin-top: 1.5rem;\n  margin-left: 1.5rem;\n}\n\n.breadcrumb-nav {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 0 0 1.25rem;\n  color: var(--ca-text-tertiary, #6f7b91);\n  font-size: 0.875rem;\n}\n\n.breadcrumb-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--ca-primary, #0e2e80);\n  font: inherit;\n  text-decoration: none;\n  cursor: pointer;\n\n  &:hover {\n    color: var(--ca-primary-dark, #0d2863);\n    text-decoration: underline;\n  }\n\n  &:focus-visible {\n    outline: 3px solid rgba(40, 80, 173, 0.25);\n    outline-offset: 3px;\n    border-radius: var(--ca-radius-sm, 6px);\n  }\n}\n\n.breadcrumb-link i {\n  font-size: 1.25rem;\n}\n\n.breadcrumb-separator {\n  color: var(--ca-text-muted, #8c96a8);\n}\n\n.breadcrumb-current {\n  \n  color: var(--ca-text-secondary, #4b5870);\n  font-weight: 500;\n}\n\n.breadcrumb-current i {\n  font-size: 1.25rem;\n}\n\n.file-system-asset-setup {\n  width: 100%;\n  padding-top: 1.25rem;\n  padding-bottom: 2.5rem;\n}\n\n.setup-page-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.setup-page-header h1 {\n  margin: 0 0 0.45rem;\n  color: var(--ca-text-primary, #172033);\n  font-size: clamp(1.55rem, 2vw, 1.9rem);\n  font-weight: 700;\n  letter-spacing: -0.025em;\n}\n\n.eyebrow {\n  margin: 0 0 0.35rem;\n  color: var(--ca-primary, #0e2e80);\n  font-size: 0.7rem;\n  font-weight: 800;\n  letter-spacing: 0.11em;\n}\n\n.page-description {\n  max-width: 760px;\n  margin: 0;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.93rem;\n}\n\n.source-type-chip,\n.format-pill,\n.count-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  flex-shrink: 0;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: 999px;\n  background: #fff;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.78rem;\n  font-weight: 600;\n  padding: 0.48rem 0.8rem;\n}\n\n.source-type-chip i {\n  color: var(--ca-primary, #0e2e80);\n}\n\n.setup-card {\n  overflow: hidden;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: 16px;\n  background: var(--ca-surface, #fff);\n  box-shadow: 0 4px 16px rgba(7, 17, 46, 0.055);\n}\n\n.setup-stepper {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 0;\n  padding: 1.25rem 1.5rem;\n  border-bottom: 1px solid var(--ca-border-light, #e9edf3);\n  background: #fbfcff;\n}\n\n.stepper-item {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  min-width: 0;\n  padding-right: 1rem;\n}\n\n.stepper-item:not(:last-child)::after {\n  position: absolute;\n  top: 1rem;\n  right: 0.85rem;\n  left: 2.7rem;\n  height: 1px;\n  background: var(--ca-border, #dfe4ec);\n  content: '';\n  transform: translateX(1rem);\n}\n\n.stepper-marker {\n  z-index: 1;\n  display: grid;\n  width: 2rem;\n  height: 2rem;\n  flex: 0 0 2rem;\n  place-items: center;\n  border: 1px solid var(--ca-border, #dfe4ec);\n  border-radius: 50%;\n  background: #fff;\n  color: var(--ca-text-muted, #8c96a8);\n  font-size: 0.82rem;\n  font-weight: 700;\n}\n\n.stepper-item.active .stepper-marker,\n.stepper-item.completed .stepper-marker {\n  border-color: var(--ca-primary, #0e2e80);\n  background: var(--ca-primary, #0e2e80);\n  color: #fff;\n}\n\n.stepper-copy {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 0.1rem;\n}\n\n.stepper-title {\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.84rem;\n  font-weight: 700;\n}\n\n.stepper-description {\n  color: var(--ca-text-muted, #8c96a8);\n  font-size: 0.72rem;\n}\n\n.stepper-item:not(.active):not(.completed) .stepper-title {\n  color: var(--ca-text-muted, #8c96a8);\n}\n\n.wizard-panel {\n  padding: clamp(1.25rem, 3vw, 2rem);\n}\n\n.panel-heading {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.9rem;\n  margin-bottom: 1.5rem;\n}\n\n.panel-heading-icon {\n  display: grid;\n  width: 2.75rem;\n  height: 2.75rem;\n  flex: 0 0 2.75rem;\n  place-items: center;\n  border-radius: 12px;\n  background: #edf3ff;\n  color: var(--ca-primary, #0e2e80);\n  font-size: 1.2rem;\n}\n\n.panel-heading-icon.success-icon {\n  background: #eaf7f0;\n  color: #198754;\n}\n\n.panel-heading h2 {\n  margin: 0 0 0.3rem;\n  color: var(--ca-text-primary, #172033);\n  font-size: 1.18rem;\n  font-weight: 700;\n}\n\n.panel-heading p {\n  margin: 0;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.88rem;\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 1.25rem 1.5rem;\n}\n\n.field-group {\n  min-width: 0;\n}\n\n.field-full {\n  grid-column: 1 / -1;\n}\n\n.form-label {\n  display: inline-block;\n  margin-bottom: 0.45rem;\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.84rem;\n  font-weight: 650;\n}\n\n.required-mark {\n  color: #dc3545;\n}\n\n.form-control,\n.form-select {\n  min-height: 2.75rem;\n  border-color: var(--ca-input-border, #dfe4ec);\n  border-radius: 8px;\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.9rem;\n  box-shadow: none;\n}\n\n.form-control:focus,\n.form-select:focus {\n  border-color: var(--ca-input-focus, #2850ad);\n  box-shadow: 0 0 0 0.2rem rgba(40, 80, 173, 0.13);\n}\n\n.field-hint,\n.field-error {\n  display: block;\n  margin-top: 0.35rem;\n  font-size: 0.76rem;\n}\n\n.field-hint {\n  color: var(--ca-text-muted, #8c96a8);\n}\n\n.field-error {\n  color: #dc3545;\n}\n\n.identity-note,\n.summary-note {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.65rem;\n  margin-top: 1.5rem;\n  padding: 0.9rem 1rem;\n  border: 1px solid #dce6ff;\n  border-radius: 10px;\n  background: #f5f8ff;\n  color: #435574;\n  font-size: 0.82rem;\n}\n\n.identity-note i,\n.summary-note i {\n  margin-top: 0.1rem;\n  color: var(--ca-primary, #0e2e80);\n  font-size: 1rem;\n}\n\n.wizard-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  margin-top: 2rem;\n  padding-top: 1.25rem;\n  border-top: 1px solid var(--ca-border-light, #e9edf3);\n}\n\n.wizard-actions-between {\n  justify-content: space-between;\n}\n\n.action-group {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: 0.65rem;\n}\n\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 2.55rem;\n  border-radius: 8px;\n  font-size: 0.84rem;\n  font-weight: 650;\n  padding: 0.55rem 1rem;\n}\n\n.btn-primary {\n  border-color: var(--ca-primary, #0e2e80);\n  background: var(--ca-primary, #0e2e80);\n}\n\n.btn-primary:hover:not(:disabled) {\n  border-color: var(--ca-primary-dark, #0d2863);\n  background: var(--ca-primary-dark, #0d2863);\n}\n\n.btn-outline-primary {\n  border-color: var(--ca-primary, #0e2e80);\n  color: var(--ca-primary, #0e2e80);\n}\n\n.btn-outline-primary:hover:not(:disabled) {\n  background: #edf3ff;\n  color: var(--ca-primary, #0e2e80);\n}\n\n.choice-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 1rem;\n}\n\n.choice-card {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.9rem;\n  width: 100%;\n  min-width: 0;\n  padding: 1.1rem;\n  border: 1px solid var(--ca-border, #dfe4ec);\n  border-radius: 12px;\n  background: #fff;\n  color: inherit;\n  text-align: left;\n  transition: border-color 0.15s ease, background-color 0.15s ease;\n}\n\n.choice-card:hover:not(:disabled) {\n  border-color: #9db7f6;\n  background: #fbfcff;\n}\n\n.choice-card.selected {\n  border-color: var(--ca-primary, #0e2e80);\n  background: #f5f8ff;\n  box-shadow: inset 0 0 0 1px var(--ca-primary, #0e2e80);\n}\n\n.choice-card:disabled {\n  cursor: not-allowed;\n  opacity: 0.8;\n}\n\n.choice-icon {\n  display: grid;\n  width: 2.55rem;\n  height: 2.55rem;\n  flex: 0 0 2.55rem;\n  place-items: center;\n  border-radius: 10px;\n  background: #edf3ff;\n  color: var(--ca-primary, #0e2e80);\n  font-size: 1.12rem;\n}\n\n.choice-icon.secondary {\n  background: #f1f3f6;\n  color: #667085;\n}\n\n.choice-content {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  gap: 0.35rem;\n  min-width: 0;\n}\n\n.choice-content strong {\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.9rem;\n}\n\n.choice-content span {\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.8rem;\n  line-height: 1.5;\n}\n\n.selection-indicator {\n  margin-top: 0.15rem;\n  color: var(--ca-text-muted, #8c96a8);\n  font-size: 1.05rem;\n}\n\n.choice-card.selected .selection-indicator {\n  color: var(--ca-primary, #0e2e80);\n}\n\n.file-import-panel {\n  margin-top: 1.5rem;\n  padding: 1.25rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: 12px;\n  background: #fcfdff;\n}\n\n.file-panel-heading,\n.table-heading {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.file-panel-heading h3,\n.table-heading h3 {\n  margin: 0 0 0.25rem;\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.98rem;\n  font-weight: 700;\n}\n\n.file-panel-heading p,\n.table-heading p {\n  margin: 0;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.8rem;\n}\n\n.format-pill {\n  border-color: #dce6ff;\n  background: #f5f8ff;\n  color: var(--ca-primary, #0e2e80);\n}\n\n.file-dropzone {\n  display: flex;\n  min-height: 210px;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.45rem;\n  padding: 1.5rem;\n  border: 1.5px dashed #b8c5dd;\n  border-radius: 12px;\n  background: #fff;\n  text-align: center;\n}\n\n.file-dropzone.has-file {\n  border-style: solid;\n  border-color: #b7e3ca;\n  background: #fbfefc;\n}\n\n.dropzone-icon {\n  display: grid;\n  width: 3.1rem;\n  height: 3.1rem;\n  margin-bottom: 0.25rem;\n  place-items: center;\n  border-radius: 50%;\n  background: #edf3ff;\n  color: var(--ca-primary, #0e2e80);\n  font-size: 1.4rem;\n}\n\n.file-selected-icon {\n  background: #eaf7f0;\n  color: #198754;\n}\n\n.file-dropzone > strong {\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.91rem;\n}\n\n.file-dropzone > span:not(.dropzone-icon) {\n  color: var(--ca-text-muted, #8c96a8);\n  font-size: 0.8rem;\n}\n\n.selected-file-name {\n  max-width: 100%;\n  overflow-wrap: anywhere;\n}\n\n.browse-button {\n  margin-top: 0.55rem;\n  cursor: pointer;\n}\n\n.text-button {\n  border: 0;\n  background: transparent;\n  color: #b42332;\n  font-size: 0.8rem;\n  font-weight: 650;\n  text-decoration: underline;\n}\n\n.file-error {\n  margin-top: 0.65rem;\n}\n\n.import-actions {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.import-context {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n  max-width: 620px;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.78rem;\n}\n\n.import-context i {\n  margin-top: 0.05rem;\n  color: var(--ca-primary, #0e2e80);\n}\n\n.import-result {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.6rem;\n  margin-top: 1rem;\n  padding: 0.85rem 1rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: 9px;\n  background: #f8faff;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.82rem;\n}\n\n.import-result-success {\n  border-color: #b7e3ca;\n  background: #f1fbf5;\n  color: #17653d;\n}\n\n.import-result-error {\n  border-color: #f3b9c0;\n  background: #fff5f6;\n  color: #a51f2d;\n}\n\n.imported-assets-section {\n  margin-top: 1.5rem;\n}\n\n.table-heading {\n  align-items: center;\n}\n\n.count-pill {\n  border-color: #dce6ff;\n  background: #f5f8ff;\n  color: var(--ca-primary, #0e2e80);\n}\n\n.assets-table-wrapper {\n  overflow: auto;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: 10px;\n}\n\n.assets-table {\n  min-width: 780px;\n  margin: 0;\n  font-size: 0.8rem;\n}\n\n.assets-table thead th {\n  padding: 0.85rem 1rem;\n  border-bottom-color: var(--ca-border, #dfe4ec);\n  background: #f5f7fb;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.72rem;\n  font-weight: 750;\n  letter-spacing: 0.025em;\n  white-space: nowrap;\n}\n\n.assets-table tbody td {\n  padding: 0.85rem 1rem;\n  border-bottom-color: var(--ca-border-light, #e9edf3);\n  color: var(--ca-text-secondary, #4b5870);\n  vertical-align: middle;\n}\n\n.assets-table tbody tr:last-child td {\n  border-bottom: 0;\n}\n\n.assets-table tbody tr:hover {\n  background: #fbfcff;\n}\n\n.assets-table td strong {\n  display: block;\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.82rem;\n}\n\n.asset-description {\n  display: block;\n  max-width: 260px;\n  margin-top: 0.2rem;\n  overflow: hidden;\n  color: var(--ca-text-muted, #8c96a8);\n  font-size: 0.72rem;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.status-pill {\n  display: inline-flex;\n  align-items: center;\n  border-radius: 999px;\n  background: #f1f3f6;\n  color: #667085;\n  font-size: 0.7rem;\n  font-weight: 700;\n  padding: 0.25rem 0.55rem;\n  text-transform: capitalize;\n}\n\n.status-pill.status-active {\n  background: #eaf7f0;\n  color: #198754;\n}\n\n.empty-assets-state {\n  display: flex;\n  min-height: 150px;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  border: 1px dashed var(--ca-border, #dfe4ec);\n  border-radius: 10px;\n  color: var(--ca-text-muted, #8c96a8);\n  text-align: center;\n}\n\n.empty-assets-state i {\n  color: var(--ca-primary, #0e2e80);\n  font-size: 1.5rem;\n}\n\n.empty-assets-state strong {\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.88rem;\n}\n\n.empty-assets-state span {\n  font-size: 0.78rem;\n}\n\n.summary-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.9rem;\n}\n\n.summary-item {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 0.4rem;\n  padding: 1rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: 10px;\n  background: #fff;\n}\n\n.summary-item-full {\n  grid-column: 1 / -1;\n}\n\n.summary-label {\n  color: var(--ca-text-muted, #8c96a8);\n  font-size: 0.74rem;\n  font-weight: 650;\n}\n\n.summary-item strong {\n  overflow-wrap: anywhere;\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.9rem;\n  font-weight: 700;\n}\n\n.summary-item .summary-success {\n  color: #198754;\n}\n\n.summary-long-value {\n  font-size: 0.8rem !important;\n}\n\n.summary-note code {\n  border-radius: 4px;\n  background: #e8eeff;\n  color: var(--ca-primary, #0e2e80);\n  font-size: 0.8rem;\n  padding: 0.12rem 0.28rem;\n}\n\n.update-panel {\n  max-width: 960px;\n  margin: 0 auto;\n}\n\n.section-divider-label {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin: 0 0 1.25rem;\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.82rem;\n  font-weight: 700;\n}\n\n.section-divider-label::after {\n  flex: 1;\n  height: 1px;\n  background: var(--ca-border-light, #e9edf3);\n  content: '';\n}\n\n.readonly-value {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  min-height: 2.75rem;\n  padding: 0.65rem 0.8rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: 8px;\n  background: var(--ca-surface-muted, #f7f9fc);\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.9rem;\n}\n\n.readonly-value i {\n  color: var(--ca-primary, #0e2e80);\n  font-size: 1rem;\n}\n\n.update-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n  min-height: 220px;\n  padding: 2rem;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.9rem;\n}\n\n.update-load-error {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.85rem;\n  padding: 1.5rem;\n  color: var(--ca-text-secondary, #4b5870);\n}\n\n.update-load-error > i {\n  color: #dc3545;\n  font-size: 1.2rem;\n}\n\n.update-load-error > span {\n  flex: 1 1 220px;\n}\n\n@media (max-width: 640px) {\n  .update-panel {\n    padding: 1rem;\n  }\n\n  .update-panel .form-grid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .update-panel .field-full {\n    grid-column: auto;\n  }\n\n  .update-panel .wizard-actions {\n    align-items: stretch;\n    flex-direction: column-reverse;\n  }\n\n  .update-panel .wizard-actions .btn {\n    width: 100%;\n  }\n}\n\n@media (max-width: 850px) {\n  .setup-page-header {\n    flex-direction: column;\n  }\n\n  .setup-stepper {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .stepper-item:not(:last-child)::after {\n    display: none;\n  }\n\n  .choice-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .stepper-description {\n    display: none;\n  }\n}\n\n@media (max-width: 600px) {\n  .file-setup-breadcrumb {\n    padding-right: 1rem;\n    padding-left: 1rem;\n  }\n\n  .file-system-asset-setup {\n    padding-right: 1rem;\n    padding-left: 1rem;\n  }\n\n  .form-grid,\n  .summary-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .field-full,\n  .summary-item-full {\n    grid-column: auto;\n  }\n\n  .wizard-panel {\n    padding: 1rem;\n  }\n\n  .import-actions,\n  .wizard-actions-between {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .action-group {\n    justify-content: flex-end;\n  }\n\n  .wizard-actions > .btn,\n  .action-group .btn {\n    flex: 1 1 auto;\n  }\n\n  .file-panel-heading,\n  .table-heading {\n    align-items: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
